.darkTheme {
  :global(.ql-snow) {
    border: thin solid var(--color-neutral-not-so-light);
  }

  :global(.ql-container) {
    height: 10rem;
    max-height: 10rem;
    overflow: auto;
    border-radius: var(--border-radius-secondary);
  }

  :global(.ql-stroke) {
    stroke: var(--color-white);
  }

  :global(.ql-fill) {
    fill: var(--color-white);
  }

  :global(.ql-editor) {
    font-size: 1.6rem;
  }

  /* placeholder styling */
  :global(.ql-editor.ql-blank::before) {
    color: var(--color-neutral-light);
  }
}

.withToolbar {
  :global(.ql-container) {
    border-radius: 0;
  }
}
